import { Action } from '@ngrx/store';

export const GET_CURRENT_USER_PERMISSIONS = '[Security] Get Current User Permissions';

export class GetCurrentUserPermissionsAction implements Action {
  readonly type = GET_CURRENT_USER_PERMISSIONS;
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/GetCurrentUserPermissionsAction.ts